import { render, staticRenderFns } from "./BlackGoldEventPage.vue?vue&type=template&id=2cac218c"
import script from "./BlackGoldEventPage.vue?vue&type=script&lang=js"
export * from "./BlackGoldEventPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports